"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _styled = _interopRequireWildcard(require("../styled"));
var _settings = _interopRequireDefault(require("../settings"));
var _recompose = require("../recompose");
var _Image = _interopRequireDefault(require("./Image"));
var _excluded = ["src", "tags", "size", "width", "height", "className", "crop"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getAspectRatioPercentage = function getAspectRatioPercentage(props) {
  return 100 * (props.height / props.width) + "%";
};
var Square = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  height: 0;\n  padding-bottom: ", ";\n"])), getAspectRatioPercentage);
var Wrapper = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n"])));
var StyledImage = (0, _styled.default)(_Image.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 100%;\n  max-height: 100%;\n"])));
var BadgeWrapper = _styled.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  position: absolute;\n  z-index: 10;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  flex-direction: column;\n  pointer-events: none;\n\n  ", ";\n"])), (0, _styled.switchProp)('position', {
  topright: (0, _styled.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n      justify-content: flex-end;\n      align-items: flex-start;\n    "]))),
  topleft: (0, _styled.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n      align-items: flex-start;\n      justify-content: flex-start;\n    "]))),
  bottomleft: (0, _styled.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteralLoose2.default)(["\n      justify-content: flex-start;\n      align-items: flex-end;\n    "]))),
  bottomright: (0, _styled.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteralLoose2.default)(["\n      justify-content: flex-end;\n      align-items: flex-end;\n    "])))
}));
var BadgeImage = _styled.default.img(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 25%;\n  height: auto;\n  max-width: ", ";\n\n  :not(:last-child) {\n    margin-right: ", ";\n    margin-bottom: ", ";\n  }\n"])), (0, _styled.rem)(120), (0, _styled.rem)(5), (0, _styled.rem)(5));
var ProductImage = function ProductImage(_ref) {
  var src = _ref.src,
    tags = _ref.tags,
    size = _ref.size,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? size : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? size : _ref$height,
    className = _ref.className,
    crop = _ref.crop,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  (0, _invariant.default)(width != null && height != null, "[ProductImage] Both 'width' and 'hight' must be specified. " + "To set a square size, only provide a 'size' value.");
  var getBadges = (0, _react.useCallback)(function (position) {
    if (!tags || !Array.isArray(tags) || tags.length === 0 || !_settings.default.badges) {
      return [];
    }
    return tags.filter(function (t) {
      return _settings.default.badges[t];
    }).filter(function (t) {
      return _settings.default.badges[t].position === position || !_settings.default.badges[t].position && position === 'topright';
    }).sort(function (a, b) {
      return (_settings.default.badges[a].order || 10) - (_settings.default.badges[b].order || 10);
    });
  }, [tags]);
  var badges = (0, _react.useMemo)(function () {
    return {
      topleft: getBadges('topleft'),
      topright: getBadges('topright'),
      bottomleft: getBadges('bottomleft'),
      bottomright: getBadges('bottomright')
    };
  }, [getBadges]);
  return /*#__PURE__*/_react.default.createElement(Square, {
    width: width,
    height: height
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledImage, Object.assign({
    src: src,
    width: width,
    height: height,
    crop: crop
  }, props))), Object.keys(badges).filter(function (position) {
    return badges[position].length > 0;
  }).map(function (position) {
    return /*#__PURE__*/_react.default.createElement(BadgeWrapper, {
      position: position,
      key: position
    }, badges[position].map(function (tag) {
      return /*#__PURE__*/_react.default.createElement(BadgeImage, {
        key: tag,
        src: _settings.default.badges[tag].src,
        alt: tag,
        title: tag
      });
    }));
  }));
};
ProductImage.defaultProps = {
  src: undefined,
  tags: [],
  className: '',
  crop: 'fit',
  width: undefined,
  height: undefined
};
var enhance = (0, _recompose.compose)(_recompose.pure);
var _default = exports.default = enhance(ProductImage);